import { productItem } from '../../common';
/**
 * 中转出发
 * @startDate
 * @endDate
 * @scanSite
 * @type
*/
export const TransitDeliveryQuery = (params) => {
  return [
    {
      // 下一站明细表
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isOriginCenter', value: '否'},
        {key: 'scanSite', value: params.scanSite},
      ]
    },
    {
      // 下一省明细表
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextProvinceArea'],
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isOriginCenter', value: '否'},
        {key: 'scanSite', value: params.scanSite},
      ],
    },
  ]
}
